module.exports = __webpack_public_path__ + "img/bookshelf02.53be93a8.jpg";